import React from 'react';
import PropTypes from 'prop-types';

// Component styles
import './navigation.scss';

// App Constants
import appRoutes from '../../constants/appRoutes';

/**
 * This component shows the navigation bar for the wtf app.
 * @extends {Component}
 */
export default class Navigation extends React.Component {
  constructor(props) {
    super(props);
    /**
     * An array of the navigation items data. The render method will iterate this and create the elements.
     * @type {Array}
     * @property {Object}
     *     @property {String} path       The item path that will match the application route path.
     *     @property {String} text       The text of the item.
     *     @property {Number} iconNumber The Number that the navigation item must show.
     */
    this.navigationItems = [
      {
        path: appRoutes.upload,
        text: 'Upload Image',
        iconNumber: 1,
      },
      {
        path: appRoutes.crop,
        text: 'Select a crop box',
        iconNumber: 2,
      },
      {
        path: appRoutes.result,
        text: 'See results',
        iconNumber: 3,
      },
    ];
  }

  /**
   * This method defines whether the item should contain the `active` class or not.
   * @param {String} itemPath The item path.
   */
  getItemClassName(itemPath) {
    return itemPath === this.removeSlashFromPath(this.props.activeItem) ? '-active' : '';
  }

  /**
   * It removes the last slash from the location path if it exists. It is removed internally, the url path is unchanged.
   * @param {String} path the route path to check.
   * @returns {String}
   */
  removeSlashFromPath(path) {
    return path[path.length - 1] === '/' ? path.substring(0, path.length - 1) : path;
  }

  /**
   * It will render each button element.
   * @param {Object} navigationItem The navigation item data.
   * @param {Number} index          Child iterator key.
   */
  renderNavigationItems(navigationItem, index) {
    const { path } = navigationItem;

    return (
      <button
        className={`wtfNavigation_item ${this.getItemClassName(path)}`}
        onClick={() => this.props.itemClicked(path)}
        key={index}
      >
        <div className={`wtfNavigation_itemShape ${this.getItemClassName(path)}`}>
          <span className={`wtfNavigation_itemShapeNumber ${this.getItemClassName(path)}`}>
            {navigationItem.iconNumber}
          </span>
        </div>
        {navigationItem.text}
      </button>
    );
  }

  render() {
    return (
      <div className='wtfNavigation'>
        {this.navigationItems.map((item, index) => this.renderNavigationItems(item, index))}
      </div>
    );
  }
}

/**
 * Declare the Navigation component PropTypes
 * @type {Object}
 * @property {String}   activeItem  It defines what is the current path active.
 * @property {Function} itemClicked This callback function will be executed after the user clicks in a navigation item.
 */
Navigation.propTypes = {
  activeItem: PropTypes.string.isRequired,
  itemClicked: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js